/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinitionRequest extends models.AppSecopsSbomDefinitionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinitionRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinitionRequest>): AppSecopsSbomDefinitionRequest {
        let obj = Object.assign(new AppSecopsSbomDefinitionRequest(), model);
        AppSecopsSbomDefinitionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinitionRequest>): AppSecopsSbomDefinitionRequest {
        if (!model) return null;
        return AppSecopsSbomDefinitionRequest.newInstance(<AppSecopsSbomDefinitionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinitionRequest) {
        if (!obj) return;

        models.AppSecopsSbomDefinitionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinitionRequest): boolean {
        if (models.AppSecopsSbomDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomDefinitionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SBOM related project ID
     */
    appsecops_project_id: string;

}
